import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CashiersPage } from './cashiers.page';

const routes: Routes = [
  {
    path: '',
    component: CashiersPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CashiersPageRoutingModule {}
